import { EventBase } from "@vp/models";
import { CommunicationData } from "../application/communications";

export class CommunicationEvent extends EventBase<CommunicationData> {
  constructor(private com: CommunicationData) {
    super();
    this.args = this.com;
  }
}
